'use client';
import{__rest as t}from"tslib";import e from"react";import r from"../BaseInput.js";const o=e.forwardRef(((o,p)=>{const{type:m="text"}=o,s=t(o,["type"]);return e.createElement(r,Object.assign({ref:p,type:m},s))}));o.displayName="TextInput";export{o as TextInput};
